var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-home-proj"}},[_c('div',{attrs:{"id":"nav-home-proj"}},_vm._l((_vm.projects),function(item,index){return _c('home-proj-module',{attrs:{"lang":_vm.lang,"projId":item,"scroll":_vm.scroll,"actScreen":_vm.actScreen,"totalScreen":_vm.totalScreen,"numScreen":(index + 1)}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df95799","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modules/HomeProj.vue
// module id = null
// module chunks = 